<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="成交日期">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              class="w220"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="searchTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称" v-if="!clienId">
            <el-input
              v-model="search.consignee"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          
          <el-form-item label="手机号" v-if="!clienId">
            <el-input
              class="w120"
              v-model="search.telephone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="门店名称" v-if="!clienId">
            <el-input
              v-model="search.shop_name"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item size="mini" label="护理师(开单人)" prop="sale_id">
            <el-select v-model="search.sale_id"    clearable remote filterable placeholder="请选择" class="w140">
              <el-option
                v-for="item in options.staff"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品/项目/品项名称" >
            <el-select v-model="search.type" @change="handleTypeChange" clearable class="w100">
              <el-option
                v-for="item in options.typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />

            </el-select>
            <el-select
              v-model="search.kingdee_code"
              clearable
              filterable
              placeholder="请输入"
              class="w220"
              remote
              :remote-method="remoteMethodGoods"
            >
              <el-option
                v-for="item in options.goodsList"
                :key="item.kingdee_code"
                :label="item.name"
                :value="item.kingdee_code"
              >
              <span>{{ item.name }}</span>
              <span style="color: #8492a6; font-size: 13px" v-if="item.spec_name">-{{ item.spec_name}}</span>
          </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售金额">
            <el-input
              v-model="search.low_total"
              maxlength="30"
              class="w84"
              placeholder="最小值"
              clearable
            />
            <span></span>
            <el-input
              v-model="search.large_total"
              maxlength="30"
              class="w84"
              placeholder="最大值"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model="search.business_type" placeholder="请选业务类型" class="w120" clearable>
              <el-option
                v-for="item in options.business_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="search.order_type" placeholder="请选订单类型" class="w120" clearable>
              <el-option
                v-for="item in options.order_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单来源">
            <el-select v-model="search.is_app" placeholder="请选订单来源" class="w120" clearable>
              <el-option
                v-for="item in options.is_app_List"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="search.status" placeholder="请选订单状态" class="w120" clearable>
              <el-option
                v-for="item in options.display_cannel"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
           <el-form-item label="品项类目选择">
            <el-cascader
              v-model="search.typepx"
              clearable
              :options="options.pxTypeList"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
          <!-- <el-form-item label="显示作废订单">
            <el-select v-model="search.display_cannel" placeholder="是否显示作废订单" class="w120" clearable>
              <el-option
                v-for="item in options.display_cannel"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item> -->
          <el-form-item label="所属病历ID">
            <el-input v-model="search.medical_id" placeholder="请输入所属病历ID" clearable class="w220" />
          </el-form-item>


        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <div class="btnBox">
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          class="mb10"
          size="mini"
          @click="tapDetail('export')"
        >导出数据</el-button>
        <div  v-if="userInfo.shop_id" ></div>
        <el-button v-if="!clienId" type="primary" class="mb10" size="mini" @click="tapDetail('lock')" >锁定订单</el-button>
        <span v-if="is_show_add">
          <el-button
          v-if="clienId && oldId == clienId"
          type="primary"
          class="mb10"
          round
          size="mini"
          @click="tapDetail('add')"
        >添加销售出库单</el-button>
        </span>
      </div>
      <el-row>
        <el-col :span="24">
          <el-table
            v-loading="table_loading"
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
            row-key="id"
            :tree-props="{children: 'goods_list', hasChildren: false}"
          >
            <!-- <ElTableColumn  v-if="!userInfo.shop_id" type="selection" width="50" /> -->
            <ElTableColumn label="订单编号" prop="order_no" width="170" />
            <ElTableColumn label="成交日期" prop="deal_time" width="90" />
            <ElTableColumn label="客户名称" prop="consignee" />
            <ElTableColumn label="手机号" prop="telephone" width="95" />
            <ElTableColumn label="客户K3代码" prop="king_no" width="90"  />
            <ElTableColumn label="门店" prop="shop_name" />
            <ElTableColumn label="开单人" prop="sale_name" />
            <ElTableColumn label="订单来源" prop="is_app_msg" />
            <ElTableColumn label="所属病历ID" prop="medical_id" />
            
            <ElTableColumn label="商品类型" prop="data_business_type" />
            <ElTableColumn label="商品名称" prop="goods_name" />
            
            <ElTableColumn label="品项一级" prop="type_one_name" />
            <ElTableColumn label="品项二级" prop="type_two_name" />
            <ElTableColumn label="品项三级" prop="type_three_name" />
            <ElTableColumn label="别名">
              <template slot-scope="{ row }">
                <span >{{row.goods_alias_name || '-'}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="业务类型">
              <template slot-scope="{ row }">
                <div>{{ row.business_type }}</div>
              </template>
            </ElTableColumn>
            <ElTableColumn label="订单类型" prop="order_type" />
            <ElTableColumn label="标准单价" prop="goods_price" />
            <ElTableColumn label="销售单价" prop="pay_price" />
            <ElTableColumn label="数量" prop="number" />
            <ElTableColumn label="标准金额" prop="" >
             <template slot-scope="{ row }">
                <span >{{row.goods_price || '-'}}</span>
              </template>
            </ElTableColumn>
            <!--  -->
            <ElTableColumn label="销售金额" >
              <template slot-scope="{ row }">
                <span >{{row.order_goods_price || row.order_amount || '-'}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="实付金额">
                 <template slot-scope="{ row }">
                <span >{{row.after_discount_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="优惠后本金">
                 <template slot-scope="{ row }">
                <span >{{row.pay_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
                 <ElTableColumn label="优惠后赠金">
                 <template slot-scope="{ row }">
                <span >{{row.gift_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
                 <ElTableColumn label="优惠后店转">
                 <template slot-scope="{ row }">
                <span >{{row.shop_transfer_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="是否存货" prop="prestock_type" />
            <ElTableColumn label="存货数量">
             <template slot-scope="{ row }">
                <span >{{row.takeout_stock_num || '-'}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="订单状态" prop="status_msg" />
            <!-- <ElTableColumn label="是否锁定" >
              <template slot-scope="{ row }">
                <span >{{row.is_lock == 0?'未锁定':'已锁定'}}</span>
                
              </template>
            </ElTableColumn> -->
            <ElTableColumn label="操作" fixed="right" v-if="oldId == clienId">
              <template slot-scope="{ row }">
                <span class="theme" v-if="clienId && row.goods_list " @click="tapDetail('销售记录详情',row.id)">查看</span>
                <span class="theme" v-if="!clienId && row.goods_list" @click="tapDetail('销售出库单详情',row.id)">查看</span>
              </template>
            </ElTableColumn>
          </el-table>
          <div class="reveal" v-if="sum_amount != 'noShow'">
            <span class="mr20">
              销售金额合计：
              <span class="peril">{{sum_amount}}</span>
            </span>
          </div>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import dateMixin from '@/mixins/dateMixin';
import { goodsList2, getGoodsAndItem,getGoodList,getProductTypeParent} from '@/api/goods'
import { searchPersonList } from '@/api/staff'
import pagination from "@/components/Pagination";
import { orderList, exportOrder, lockOrder } from "@/api/order";
import { convertToTreeData } from '@/utils/constants';

class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Search { 
  typepx='';
  medical_id = "";
  kingdee_code = "";
  sale_id = "";
  status = 1;
  start_time = "";
  end_time = "";  
  consignee = "";
  telephone = "";
  is_app = "";
  shop_name = "";
  low_total = "";
  large_total = "";
  business_type = "";
  order_type = "";
  display_cannel = 0;
}
class Options {
  pxTypeList = [];
  staff=[];
  typeList = [
    { id: 1, name: '品项' },
    { id: 2, name: '商品' },
    { id: 3, name: '服务' }
  ];
  goodsList=[];
  business_type = [
    { id: 1, name: "疤痕" },
    { id: 2, name: "项目" },
	{ id: 3, name: "青春痘" },
	{ id: 4, name: "护肤品" }
  ];
  order_type = [
    { id: 1, name: "新单" },
    { id: 2, name: "补单" }
  ];
  is_app_List = [
    { id: 0, name: "中台" },
    { id: 1, name: "小程序" }
  ];
  display_cannel = [
  // { id: 0, name: "不显示" },
  // { id: 1, name: "显示" }
    { id: 1, name: "未作废" },
    { id: 4, name: "已作废" }
  ];
}
export default {
  name: "OrderList",
   mixins: [dateMixin], 
  components: {
    pagination
  },
  props: {
    clienId: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      table_loading: false,
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: "",
      oldId:"",
      value1: [],
      sum_amount: "noShow",
      is_show_add:true
    };
  },
computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.search.medical_id = this.$route.query.medical_id || ''
    if(this.clienId){
      this.oldId = this.$route.query.id.toString()
    }else{
      this.setDefaultDate(); // 直接调用混入的方法
    }
    this.getList();
    this.getGoods();
  },
  methods: {
    handleTypeChange(val){
      this.search.kingdee_code = ""
      if(val == 1){
        this.remotePxMethod('');
      }else if(val == 2){
        this.remoteSpMethod('');
      }else if(val == 3){
        this.remoteFwMethod('');
      }
      
    },
    remoteMethodGoods(query){
      if( this.search.type == 1){
        this.remotePxMethod(query);
      }else if(this.search.type == 2){
        this.remoteSpMethod(query);
      }else if(this.search.type == 3){
        this.remoteFwMethod(query);
      }
    },
    remoteSpMethod(query) {
      getGoodList({ type:2,action:'search',name: query }).then(res=>{
        this.options.goodsList = res;
      })
    },
    remoteFwMethod(query) {
      getGoodList({ type:3,action:'search',name: query }).then(res=>{
        this.options.goodsList = res;
      })
    },
    remotePxMethod(query) {
      getGoodList({ type:1, shop_id:this.userInfo.shop_id,name: query,action:'search'}).then(res=>{
        this.options.goodsList = res;
      })
    },  
    getGoods () {
      // goodsList2({page: 1, limit: 100000 }).then(
      //   res => {
      //     this.options.goodsList = res.list
      //   }
      // )
    
      getGoodsAndItem().then(
        res => {
          // this.options.goodsList = res
        }
      )
          // 客户所在店铺员工列表
      searchPersonList().then(
        res => {
          this.options.staff = res
        }
      )
        getProductTypeParent({ level : 'three' }).then(res => {
            this.options.pxTypeList  = convertToTreeData(res.data);
          })
    },
    // 获取列表
    getList(option) {
      this.table_loading = true
      if (option == "search") this.page = new Page();
      orderList({
        ...this.search,
        type_one:this.search.typepx[0] || '',
        type_two:this.search.typepx[1] || '',
        type_three:this.search.typepx[2] || '', 
        ...this.page,
        uid: this.clienId ? this.clienId : "",
      }).then(res => {
        this.table_loading = false
        this.is_show_add = res.is_show_add
        this.list = res.list;
        this.page.total = res.dataCount;
        if (this.search.end_time) {
          this.sum_amount = res.sum_amount;
        } else {
          this.sum_amount = "noShow";
        }
      });
    },
    // 日期搜索
    searchTime(val) {
      if (val) {
        this.search.start_time = val[0];
        this.search.end_time = val[1];
      } else {
        this.search.start_time = "";
        this.search.end_time = "";
      }
    },
    // 点击按钮
    tapDetail(type, id) {
      switch (type) {
        case "销售出库单详情":
          this.$router.push("./orderDetail?id=" + id + "&type=order");
          break;
        case "销售记录详情":
          const queryD = { id: id,  clienId: this.clienId,detail: this.detail, activeName: "second1",activeTab:'salesRecords' };
          this.$router.push({ name: "销售出库单详情", query: queryD });
          break;
        case "add":
          const query = { clienId: this.clienId, detail: this.detail };
          this.$router.push({ name: "创建订单", query });
          break;
        case "export":
          this.hint("导出选中列表", "export");
          break;
        case "lock":
          if (this.search.end_time) {
            this.hint("锁定选中条件的订单", "lock");
          } else {
            this.$message({
              message: "请选择锁定日期",
              type: "warning"
            });
          }
          break;
      }
    },
    // 提示
    hint(text, type) {
      this.$confirm(`${text},是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "export") {
            this.getExport();
          } else {
            this.getLockOrder();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //锁单
    getLockOrder() {
      lockOrder({ ...this.search }).then(res => {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getList();
      });
    },
    // 导出
    getExport() {
      this.fullscreenLoading = true
      console.log(111)
        exportOrder({ ...this.search,  
          type_one: this.search.typepx[0] || '',
          type_two: this.search.typepx[1] || '',
          type_three: this.search.typepx[2] || '',
          uid: this.clienId ? this.clienId : "",
        }).then(res=>{
          this.fullscreenLoading = false
          window.open(res.data.url);
        }).catch((err)=>{
          console.log(err)
          this.fullscreenLoading = false
        })    
      },
    // 改变表格选中状态
    handleSelectionChange(val) {
      this.idList = val.map(i => {
        return i.id;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bgW {
  background: #fff;
  border-radius: 3px;
  //   padding: 10px;
  margin-bottom: 20px;
}
.el-form-item {
  margin: 5px 10px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 10px 0px 80px;
}
.reveal {
  text-align: right;
  padding: 20px 0;
  .peril {
    font-weight: bold;
  }
}
.btnBox {
  display: flex;
  column-gap: 10px;
  }
</style>
